import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button as BaseButton, Modal, Typography } from '@figure/frontlib-gui';
import Stack from 'shared/components/Stack';

const Button = styled(BaseButton)`
  margin-top: 32px;
`;

const InstructionModal = ({ isOpen, handleClose }) => {
  const [t] = useTranslation('translation');
  return (
    <Modal size="sm" isOpen={isOpen} onClose={handleClose} header="Great Job! Let's quickly verify your income.">
      <Stack space="16px">
        <Typography.BodyBold>Please note: your privacy is extremely important to us.</Typography.BodyBold>

        <Typography.Body>
          We use trusted, third party applications to link accounts and information. This allows us to automatically verify your income
          and safely deliver your funds without the headache of extensive paperwork.
        </Typography.Body>

        <Typography.Body>
          Your data is protected with 256-bit encryption and {t('companySingleName')} never sees or stores your credentials.
        </Typography.Body>

        <Button primary center large onClick={handleClose} data-test-id="verify-income-continue">
          Continue
        </Button>
      </Stack>
    </Modal>
  );
};

InstructionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default InstructionModal;
